// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 331) return "static/css/331.2515132f730095f2978a.css";
	if (chunkId === 7564) return "static/css/sender.2af543adeeab849813bb.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"688":"29cf82809a7704253cdc","1412":"83971b4df2c901ec0bdb","1487":"38dd8bc41dad7df9900d","3380":"e7369794cddb97eeca78","4514":"e7369794cddb97eeca78","6877":"29cf82809a7704253cdc","6952":"29cf82809a7704253cdc","9010":"e7369794cddb97eeca78"}[chunkId] + ".chunk.css";
};